import { render, staticRenderFns } from "./ModalNotes.vue?vue&type=template&id=6a37de8f&scoped=true&"
import script from "./ModalNotes.vue?vue&type=script&lang=js&"
export * from "./ModalNotes.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotes.vue?vue&type=style&index=0&id=6a37de8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37de8f",
  null
  
)

export default component.exports